import {
    Button,
    Label,
    makeStyles,
    shorthands,
    tokens,
} from '@fluentui/react-components';
import { Delete24Regular } from '@fluentui/react-icons';
import React from 'react';
import { DeleteNewsDialog } from './DeleteNewsDialog';
import { useState } from 'react';

const useClasses = makeStyles({
    header: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        minHeight: '32px',
        ...shorthands.padding(tokens.spacingVerticalS, tokens.spacingHorizontalM),
        ...shorthands.borderBottom('1px', 'solid', tokens.colorNeutralStroke1),
    },
    title: {
        display: 'flex',
        alignItems: 'center',
        ...shorthands.gap(tokens.spacingHorizontalS),
        fontSize: tokens.fontSizeBase300,
    },
    icon: {
        fontSize: '20px',
    },
    deleteButton: {
        minWidth: 'auto',
    },
    headerActions: {
        display: 'flex',
        gap: '8px',
    },
});

interface NewsListHeaderProps {
    selectedNewsIds: string[];
    onDeleteSelected: (ids: string[]) => void;
    setSelectedNewsIds: React.Dispatch<React.SetStateAction<string[]>>;
}

export const NewsListHeader: React.FC<NewsListHeaderProps> = ({
    selectedNewsIds,
    onDeleteSelected,
    setSelectedNewsIds,
}) => {
    const classes = useClasses();
    const [open, setOpen] = useState(false);

    return (
        <div className={classes.header}>
            <div className={classes.title}>
                <Label weight="semibold">Newsfeed Verwaltung</Label>
            </div>
            <div className={classes.headerActions}>
                {selectedNewsIds.length > 0 && (
                    <Button
                        icon={<Delete24Regular />}
                        appearance="primary"
                        className={classes.deleteButton}
                        onClick={() => { setOpen(true)} }
                        title="Ausgewählte News löschen"
                        aria-label="Ausgewählte News löschen"
                    >
                        ({selectedNewsIds.length})
                    </Button>
                )}
                <DeleteNewsDialog
                    open={open}
                    onClose={() => { setOpen(false)} }
                    onConfirm={() => {
                        onDeleteSelected(selectedNewsIds);
                        setSelectedNewsIds([]);
                        setOpen(false);
                    }}
                    count={selectedNewsIds.length}
                />
            </div>
        </div>
    );
};
